import { Aggregator } from '@/modules/core/charts/pivottable/composables/pivotAggregator';

export const PivotAxis = {
  ROWS: 'rows',
  COLUMNS: 'columns',
  MEASURES: 'measures',
};

export const PivotDefaultAggregator = Aggregator.SUM;

export const PivotEmptyValueRepresentation = Object.freeze({
  DASH: '-',
  ZERO: '0',
  STAR: '*',
  BLANK: '',
});

export const PivotDefaultEmptyValueRepresentation = PivotEmptyValueRepresentation.DASH;

export const PivotTextOverflow = Object.freeze({
  NOWRAP: 'nowrap',
  WRAP: 'wrap',
  ELLIPSIS: 'ellipsis',
});

export const PivotDefaultTextOverflow = PivotTextOverflow.ELLIPSIS;

export const PIVOT_HEADER_MAX_WIDTH_PX = 200;

export const PIVOT_INDENT_PER_LEVEL = 32;

export const PIVOT_BASE_PADDING = 8;

export const PivotMaxRows = Object.freeze({
  DEFAULT: 10000,
  MIN: 1000,
  MAX: 50000,
});
